export default [
    {
        path: '/purchase-orders',
        name: 'PurchaseOrders',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER', 'FINANCE', 'OPS'],
            denyRoles: null,
            title: 'Purchase orders',
        },
        components: {
            default: () => import('@views/purchase-orders/PurchaseOrderIndex.vue'),
        },
    },
];
